import { useMemo } from 'react';

import { Glyph } from '../common/Glyph';
import { SpinnerLoading } from '../common/SpinnerLoading';

import { useDevicesSelection } from '../../store/devices/useDevices.ts';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';

import { IndicatorCapability } from './IndicatorCapability';
import { IndicatorUnavailableStatus } from './IndicatorUnavailableStatus';

export function Indicator(props) {
  if (props.device == null) {
    return null;
  }

  if (props.device.ready === null) {
    return <SpinnerLoading size={24} />;
  }

  if (props.device.available === false || props.device.ready === false) {
    return <IndicatorUnavailableStatus />;
  }

  if (props.device.driverId === 'homey:virtualdrivergroup:driver') {
    return <IndicatorGroup device={props.device} tileSize={props.tileSize} />;
  }

  return <IndicatorCapability device={props.device} tileSize={props.tileSize} />;
}

function IndicatorGroup(props) {
  const deviceIds = props.device.settings.deviceIds ?? [];
  const selection = useDevicesSelection({ deviceIds });

  const isSomeDeviceUnavailable = useMemo(() => {
    return Object.values(selection).some((device) => {
      // If the device was not found ignore it for the available status.
      if (device == null) {
        return false;
      }

      return device.available === false;
    });
  }, [selection]);

  if (isSomeDeviceUnavailable) {
    return (
      <Glyph
        source={glyph.core.exclamationmarkTriangleFill}
        color={theme.color.warning}
        size={theme.icon.size_medium}
      />
    );
  }

  return <IndicatorCapability device={props.device} tileSize={props.tileSize} />;
}
